import * as type from "../action-types";

const initialState = {
  sectors: [],
  loading: false
};

// handles actions
// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case type.GET_SECTORS:
      return { ...state, loading: true };
    case type.GET_SECTORS_SUCCESS:
      return { ...state, sectors: action.payload.data, loading: false };
    case type.GET_SECTORS_FAILURE:
      return { ...state, sectors: [], loading: false };
    default:
      return state;
  }
};
